import React, { useState } from 'react';
import DatePickerLib from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.css';

const DatePicker = ({ 
  value, 
  onChange, 
  placeholder = 'Select date...', 
  className = '', 
  disabled = false,
  minDate,
  maxDate,
  showTimeSelect = false,
  dateFormat = 'MM/dd/yyyy',
  ...props 
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDateChange = (date) => {
    onChange(date);
    setIsOpen(false);
  };

  const handleInputClick = () => {
    if (!disabled) {
      setIsOpen(true);
    }
  };

  return (
    <div className={`date-picker-container ${className}`}>
      <i className="fas fa-calendar date-picker-icon"></i>
      <DatePickerLib
        selected={value}
        onChange={handleDateChange}
        onClickOutside={() => setIsOpen(false)}
        onInputClick={handleInputClick}
        open={isOpen}
        placeholderText={placeholder}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        showTimeSelect={showTimeSelect}
        dateFormat={dateFormat}
        className="date-picker-input"
        popperClassName="date-picker-popper"
        popperPlacement="bottom-start"
        {...props}
      />
    </div>
  );
};

export default DatePicker; 